import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import CancelBookingForm from './CancelBookingForm/CancelBookingForm';
import messages from '../../locale/messages';
import { closeCancelBookingModal } from '../../actions/siteadmin/modalActions';
import bt from '../../components/commonStyle.css';
import s from './CancelBookingModal.css';

class CancelBookingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userType: 1
        }
    }

    handleSelect = async (key) => {
        const { change } = this.props;
        let userType = key?.target?.value;
        this.setState({ userType: userType });
        change('CancelBookingForm', 'requestBy', userType == 2 ? 'cancelledByPartner' : 'cancelledByUser');
    }

    render() {
        const { cancelBookingModal, closeCancelBookingModal } = this.props;
        const { userType } = this.state;
        const { formatMessage } = this.props.intl;

        return (
            <>
                <Modal show={cancelBookingModal} onHide={closeCancelBookingModal} dialogClassName='commonModalContainer' >
                    <Modal.Header closeButton className='commonModalHeader'>
                        <Modal.Title>
                            <div className="commonModalTitle"> <FormattedMessage {...messages.cancelJob} /></div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='commonModalBody'>
                        <div className={cx(s.cancelBookingModalInfoHeading)}><FormattedMessage {...messages.cancelJobContent} /></div>
                        <div>
                            <div className={cx(bt.commonLabelText)}><FormattedMessage {...messages.canceledBy} /></div>
                            <select value={userType} onChange={(e) => { this.handleSelect(e) }} className={cx(bt.formControlSelect)}>
                                <option value={1}>{formatMessage(messages.user)}</option>
                                <option value={2}>{formatMessage(messages.partner)}</option>
                            </select>
                        </div>
                        {userType == 1 && <CancelBookingForm userType={userType} closeCancelBookingModal={closeCancelBookingModal} />}
                        {userType == 2 && <CancelBookingForm userType={userType} closeCancelBookingModal={closeCancelBookingModal} />}
                    </ Modal.Body >
                </Modal>
            </>
        )
    }
}
const mapState = (state) => ({
    cancelBookingModal: state.adminModalStatus.cancelBookingModal
});

const mapDispatch = {
    closeCancelBookingModal,
    change
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(CancelBookingModal)));